import { PermissionRoute, type PermissionRouteData } from '@exam-management/permission-route';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';

export default function QSetReviewSubtaskRouteController() {
  const { taskId, subTaskId } = useParams(
    '/task-management/qset-review/:taskId/subtask/:subTaskId',
  );
  const defaultRoutes: PermissionRouteData[] = [
    {
      path: '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
      params: {
        taskId,
        subTaskId,
      },
    },
    {
      path: '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
      params: {
        taskId,
        subTaskId,
      },
    },
    {
      path: '/task-management/qset-review/:taskId/subtask/:subTaskId/review-result',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
      params: {
        taskId,
        subTaskId,
      },
    },
  ];

  return <PermissionRoute routes={defaultRoutes} />;
}
